  import { Component, OnInit } from '@angular/core';
  import { ActivatedRoute } from '@angular/router';
  import { ModalController } from '@ionic/angular';
  import { User } from 'src/app/models/user.model';
  import { Visitor } from 'src/app/admin/models/visitor';
  import { AccountService } from 'src/app/services/account.service';
  import { VisitService } from 'src/app/admin/services/visit.service';
  import { VisitorService } from 'src/app/admin/services/visitor.service';
  import { validateVisit } from 'src/app/utils/formValidators';
  import { environment } from 'src/environments/environment';


  @Component({
    selector: 'app-blocked-status',
    templateUrl: './blocked-status.component.html',
    styleUrls: ['./blocked-status.component.scss'],
  })
  export class BlockedStatusComponent implements OnInit {
  visitor:  Visitor;
    errMsg = '';
    msg = '';
    connection;
    disconnectedOnPurpose = false;
    apiUrl = environment.apiUrl;
    visitors$ = this.visitorService.visitors$;
    roomId;
    // eslint-disable-next-line @typescript-eslint/no-inferrable-types
    fullNameBlockedVisitorsQuery: string = '';
    // eslint-disable-next-line @typescript-eslint/no-inferrable-types
    currentPage: number = 1;
    // eslint-disable-next-line @typescript-eslint/no-inferrable-types
    itemsPerPage: number = 20;

    constructor(private modalController: ModalController, private visitService: VisitService,
      private visitorService: VisitorService, private accountService: AccountService) {
      }

    ngOnInit() {
      if(this.visitor){
      // eslint-disable-next-line @typescript-eslint/quotes
      this.visitor.comment = "Korisnik je vratio karticu";
    }}

    editStatus() {
      this.visitorService.editVisitor(this.visitor).subscribe(res => {
      /* this.visitorService.getAllBlockedVisitor({currentPage: this.currentPage, itemsPerPage: this.itemsPerPage,
      fullNameBlockedVisitorsQuery: this.fullNameBlockedVisitorsQuery}); */
        this.visitorService.getAllBlockedVisitorEdit({
          currentPage: this.currentPage, itemsPerPage: this.itemsPerPage,
          fullNameBlockedVisitorsQuery: this.fullNameBlockedVisitorsQuery,
          
          
          
        });
      
      this.dismissModal();
      });
      }

    dismissModal() {
      this.modalController.dismiss();
    }
    }
